"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { createElement, useState, useEffect } from 'react';
import 'mobx';
import '../../../../../../lib/controller/overlay/context.mjs';
import { useOnChange } from '../../../../../../lib/hooks/useOnChange.mjs';
import '@react-aria/utils';
import '../../../../../../lib/propsContext/propsContext.mjs';
import 'remeda';
import '@mittwald/react-tunnel';
import '../../../../../../lib/slotContext/slotContext.mjs';
import '../../../../../../lib/viewComponentContext/viewComponentContext.mjs';
import 'dot-prop';
import SearchFieldView from '../../../../../../views/SearchFieldView.mjs';
import styles from './SearchField.module.scss.mjs';

const autoSubmitTimeout = 800;
const DefaultSearchFieldRender = (props) => {
  const { onChange, value, autoSubmit, ...searchFieldProps } = props;
  const [searchString, setSearchString] = useState(value ?? "");
  const submitSearch = () => {
    if (searchString.trim() === "") {
      onChange(void 0);
    } else {
      onChange(searchString);
    }
  };
  useEffect(() => {
    if (autoSubmit) {
      const timeout = setTimeout(() => submitSearch(), autoSubmitTimeout);
      return () => clearTimeout(timeout);
    }
  }, [searchString, autoSubmit]);
  useOnChange(value, () => {
    setSearchString(value ?? "");
  }, [searchString]);
  const clearSearch = () => {
    onChange(void 0);
    setSearchString("");
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      submitSearch();
    } else if (e.key === "Escape") {
      clearSearch();
    }
  };
  return /* @__PURE__ */ jsx(
    SearchFieldView,
    {
      className: styles.searchField,
      value: searchString,
      onKeyUp: handleKeyPress,
      onChange: (value2) => setSearchString(value2),
      onClear: clearSearch,
      ...searchFieldProps
    }
  );
};
const SearchField = (props) => {
  const { search } = props;
  const render = search.render ?? DefaultSearchFieldRender;
  return createElement(render, {
    value: search.value,
    onChange: search.setValue.bind(search),
    ...search.textFieldProps
  });
};

export { SearchField, SearchField as default };
//# sourceMappingURL=SearchField.mjs.map
